module.exports = __webpack_public_path__ + "static/img/img_14.91a7fe2d.png";